/**
 * The AddItemButton function is a React component that renders a button with specified text and
 * onClick event handler.
 * @returns A button component is being returned with the specified className and onClick event
 * handler. The button displays the text "+ {buttonText}" where {buttonText} is a variable passed as a
 * prop to the AddItemButton component.
 */
const AddItemButton = ({ onClick, buttonText }) => {
  return (
    <button
      className="btn btn-outline-info btn-lg px-4 me-sm-3 fw-bold"
      onClick={onClick}
    >
      <b>+ {buttonText}</b>
    </button>
  );
};

export default AddItemButton;
